import { render, staticRenderFns } from "./InsurerLogo.vue?vue&type=template&id=7fb24fb7&"
import script from "./InsurerLogo.vue?vue&type=script&lang=js&"
export * from "./InsurerLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports